// src/App.tsx
import React from 'react';
import {BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Pages
import Home from './pages/user/Home';
import Login from './pages/auth/Login';
import Register from './pages/auth/Registration';
import Leaderboard from './pages/user/Leaderboard';
import HowItWorks from './pages/user/HowItWorks';
import ContestRegistration from './pages/user/ContestRegistration';
import MyContest from './pages/user/MyContest';


// Components
import TopBar from './components/layout/TopBar';
import ContactUs from './components/home/ContactUs';
import ForgetPassword from './components/auth/ForgetPassword';
import ResetPassword from './components/auth/ResetPassword';
import ConfirmEmail from './components/auth/ConfirmEmail';
import Terms from './components/legal/Terms';

//Settings
import Settings from './settings/Settings';
import ChangePassword from './settings/ChangePassword';
import UpdateEmail from './settings/UpdateEmail';
import ConfirmNewEmail from './settings/ConfirmNewEmail';
import UpdateMobile from './settings/UpdateMobile';
import EditProfile from './settings/EditProfile';
import Profile from './settings/Profile';
import HallTicket from './settings/HallTicket';

// Admin
import AdminDashboard from "./pages/admin/AdminDashboard";
import CreateContest from './pages/admin/CreateContest';
import ManageContests from './pages/admin/ManageContests';
import EditContest from './pages/admin/EditContest';
import ManageQuestions from './pages/admin/ManageQuestions';
import ViewQuestions from './pages/admin/ViewQuestions';
import EditQuestion from './pages/admin/EditQuestion';
import CreateQuestion from './pages/admin/CreateQuestion';
import ViewContestRegistrations from './pages/admin/ViewContestRegistrations';
import ExamPage from './pages/user/ExamPage';
import ExamSubmitted from './pages/user/ExamSubmitted';

const App: React.FC = () => {
 
  return (
    <Router>
    <div className="app-container">
      <TopBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/contest-registration" element={<ContestRegistration />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/forgetpassword" element={<ForgetPassword />} />
        <Route path="/confirm-email" element={<ConfirmEmail />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/my-contest" element={<MyContest />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/settings/change-password" element={<ChangePassword />} />
        <Route path="/settings/update-email" element={<UpdateEmail />} />
        <Route path="/confirm-new-email" element={<ConfirmNewEmail />} />
        <Route path="/settings/update-mobile" element={<UpdateMobile />} />
        <Route path="/settings/edit-profile" element={<EditProfile />} />
        <Route path="/settings/profile" element={<Profile />} />
        <Route path="/settings/hall-ticket" element={<HallTicket />} />

        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/create-contest" element={<CreateContest />} />
        <Route path="/admin/manage-contests" element={<ManageContests />} />
        <Route path="/admin/edit-contest/:id" element={<EditContest />} />
        <Route path="/admin/questions" element={<ManageQuestions />} />
        <Route path="/admin/questions/:id" element={<ViewQuestions />} />
        <Route path="/admin/edit-question/:questionId" element={<EditQuestion />} />
        <Route path="/admin/create-question/:contestId" element={<CreateQuestion />} />
        <Route path="/admin/registrations" element={<ViewContestRegistrations />} />
        <Route path="/exam" element={<ExamPage />} />
        <Route path="/exam/submitted" element={<ExamSubmitted />} />

      </Routes>
    </div>
    </Router>
  );
};

export default App;